import { CoreOptions as AdyenOptions } from '@adyen/adyen-web/dist/types/core/types';
import IPaymentProvider from './IPaymentProvider';
import PaymentComponentConfiguration from './PaymentComponentConfiguration';
import MerchantServicesPaymentProvider from './MerchantServicesPaymentProvider';
import PaymentProvider from './PaymentProvider';

class PaymentProviderFactory {
  static create(config: { adyenOptions?: AdyenOptions,
    paymentComponentConfiguration?: PaymentComponentConfiguration }): IPaymentProvider | undefined {
    if (!config.adyenOptions && !config.paymentComponentConfiguration) {
      return undefined;
    }

    const $target = document.querySelector<HTMLElement>('#tn-payment-drop-target');

    if (!$target) {
      return undefined;
    }

    let paymentProvider: IPaymentProvider;

    if (config.paymentComponentConfiguration) {
      paymentProvider = new MerchantServicesPaymentProvider(config.paymentComponentConfiguration);
    } else {
      paymentProvider = new PaymentProvider(config.adyenOptions as AdyenOptions);
    }

    paymentProvider.setup($target);

    return paymentProvider;
  }
}

export default PaymentProviderFactory;
